import useFavoritedProductIds from 'hooks/useFavoritedProductIds';
const useFavoriteCount = () => {
  const {
    data
  } = useFavoritedProductIds();
  return data?.productIds.length ?? 0;
};
export default useFavoriteCount;